import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { TicketDashboardPageComponent } from './ticket-dashboard-page.component';

const routes: Routes = [
  {
    path: 'ticket-dashboard-page',
    data: { name: 'Ticket Dashboard', isTab: false },
    component: TicketDashboardPageComponent,
  },
  {
    path: 'ticket-dashboard-page',
    data: { name: 'Ticket TAT Time Report', isTab: true },
    component: TicketDashboardPageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TicketDashboardPageRoutingModule {}
